import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { ButtonPosition, ToastType } from '../toast.type';

@Component({
  selector: 'mode-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastComponent implements OnChanges {
  @Input() type: ToastType = 'success';
  @Input() hideIcon = false;
  @Input() showCloseBtn = false;
  @Input() closeBtnPosition: ButtonPosition = 'center';
  @Input() canTapToDismiss = false;
  @Output() dismissToast = new EventEmitter();

  icon = '';

  private _iconRecord: Record<ToastType, string> = {
    success: 'icon-check',
    info: 'icon-refresh',
    warning: '',
    error: 'icon-close',
  };

  ngOnChanges(): void {
    this.icon = this._iconRecord[this.type];
  }
}
